/**
 * Login API Service
 *
 * Handles the authentication API call. Credentials are encrypted
 * before being sent (encryption happens in the saga layer).
 * This is the only service that does NOT use makeApiCall since
 * the user is not yet authenticated (no JWT token available).
 */
import axios from 'axios';
import { API_URL } from '../config';

/**
 * Sends encrypted login credentials to the authentication endpoint.
 * @param data - Encrypted credential string (AES-CBC encrypted, hex-encoded)
 * @returns Promise with the API response containing encrypted user data and JWT token
 */
export const login = async (data: any) => {
	const URL = `${API_URL}LoginDetails`;
	const requestData = {
		LoginDetailsToken: data,
	};
	return axios.post(URL, requestData, { headers: { 'Content-Type': 'application/json' } });
};
